import { streamPackageCardV2Main } from '@synoptic/ui-kit/stream-package-card-v2/stream-package-card-v2.css.js';
import {
  StreamPackageCardV2,
  StreamPackageCardV2Body,
  StreamPackageCardV2Cover,
  StreamPackageCardV2Footer,
  StreamPackageCardV2Header,
  StreamPackageCardV2Streams,
} from '@synoptic/ui-kit/stream-package-card-v2/stream-package-card-v2.js';
import { clsx } from 'clsx';
import { StreamPackageCardV2FragmentFragment } from '@/__generated__/graphql.ts';
import { getUserAvatarSrc } from '@/components/s3/user/get-user-avatar-src.ts';
import { Link } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import { formatNumber } from '@/utils/format-number.ts';
import { streamPackageCardLinkV2 } from './stream-package-card-link-v2.css.ts';
import { streamPackageCoverSrc } from './stream-package-covers.ts';
import { streamPackagePriceV2 } from './stream-package-price-v2.ts';

const VISIBLE_INCLUDED_STREAMS = 6;

export const StreamPackageCardLinkV2 = ({
  streamPackage,
}: {
  streamPackage: StreamPackageCardV2FragmentFragment;
}) => {
  const packageHref = paths.makeStreamPackage(streamPackage.id);
  const authorHref = paths.makeUser(streamPackage.author.username);
  const { includedStreams } = streamPackage;
  const visibleStreams = includedStreams.slice(0, VISIBLE_INCLUDED_STREAMS);
  const remaining = Math.max(0, includedStreams.length - visibleStreams.length);
  const coverSrc = streamPackageCoverSrc(streamPackage.id);

  return (
    <StreamPackageCardV2>
      <Link
        className={clsx(streamPackageCardLinkV2, streamPackageCardV2Main)}
        to={packageHref}
        data-testid="stream-package-card-link-v2"
      >
        {coverSrc ? <StreamPackageCardV2Cover src={coverSrc} /> : null}
        <StreamPackageCardV2Header
          streamCount={includedStreams.length}
          price={streamPackagePriceV2(streamPackage)}
        />
        <StreamPackageCardV2Body
          title={streamPackage.name}
          description={streamPackage.description}
        />
        {visibleStreams.length > 0 ? (
          <StreamPackageCardV2Streams
            streams={visibleStreams}
            remaining={remaining}
          />
        ) : null}
      </Link>
      <StreamPackageCardV2Footer
        handle={streamPackage.author.username}
        avatarSrc={getUserAvatarSrc(
          streamPackage.author.id,
          streamPackage.author.avatar?.key,
          'v2s',
        )}
        followers={formatNumber(streamPackage.subscribersCount)}
        renderHandle={
          <Link to={authorHref} data-testid="stream-package-card-author-v2" />
        }
      />
    </StreamPackageCardV2>
  );
};
